import { Box, useStyleConfig } from "@chakra-ui/react";

const CardHeader = (props: any) => {
	const { variant, children, ...rest } = props;
	const styles = useStyleConfig("CardHeader", { variant });

	return (
		<Box __css={styles} {...rest}>
			{children}
		</Box>
	);
}

export default CardHeader;
